import TalentPicks from "./src";
import TalentPickList, {
  TalentPicksPgP
} from "./src/components/TalentPickList";

export { TalentPickList, TalentPicksPgP };
export default TalentPicks;
